module.exports = __webpack_public_path__ + "img/Qing.5ddebe4d.jpg";